import { criarCatalogoColunas } from '@/utils/catalogoColunas';

/**
 * Catálogo de colunas da tela de Acompanhamento.
 *
 * Fonte única: o grid, o configurador de colunas e as predefinições leem daqui. `padrao` define
 * o que aparece para quem nunca configurou nada.
 *
 * `sortable` só é true onde o backend sabe ordenar (whitelist em
 * AcompanhamentoController::ORDENACAO_PERMITIDA). A coluna marcada com `tenant` é consultada
 * depois da paginação, uma a uma — ordenar por ela reordenaria apenas as linhas da página
 * corrente, o que seria pior do que não oferecer a ordenação.
 */
export const COLUNAS = [
    { value: 'id', text: 'ID', padrao: true, sortable: true },
    { value: 'fantasia', text: 'Fantasia', padrao: true, sortable: true, fixa: true },
    { value: 'razao_social', text: 'Razão Social', padrao: false, sortable: true },
    { value: 'whatsapp', text: 'Wpp', padrao: true, sortable: false },
    { value: 'implementacao', text: 'Criação', padrao: true, sortable: true },
    { value: 'configuracao_impressora', text: 'Config. Impressora', padrao: true, sortable: true },
    { value: 'configuracao_taxa_entrega', text: 'Config. Taxa de Entrega', padrao: true, sortable: true },
    { value: 'tipo_taxa_entrega', text: 'Taxa de Entrega', padrao: true, sortable: true },
    { value: 'impressora', text: 'Tem Impressora?', padrao: true, sortable: true },
    { value: 'conexao_whatsapp', text: 'Con. Whats', padrao: true, sortable: false, tenant: true },
    { value: 'chave_pix', text: 'Pix', padrao: true, sortable: true },
    { value: 'pix_automatizado', text: 'PIX Autom.', padrao: false, sortable: true },
    { value: 'cadastro_entregador', text: 'Entregador', padrao: true, sortable: true },
    { value: 'dispositivos', text: 'Dispositivos', padrao: true, sortable: false },
    { value: 'horarios', text: 'Horários', padrao: true, sortable: false },
    { value: 'observacoes', text: 'Observações', padrao: true, sortable: false },
    { value: 'created_at', text: 'Cadastro', padrao: true, sortable: true },
    { value: 'assinatura_id', text: 'Ass. Número', padrao: false, sortable: true },
    { value: 'assinatura_emissao', text: 'Ass. Emissão', padrao: false, sortable: true },
    { value: 'trial_started_at', text: 'Teste Iniciado', padrao: false, sortable: true },
    { value: 'ativo', text: 'Status', padrao: false, sortable: true },
    { value: 'pedidos_ultimos_7_dias_count', text: 'Pedidos Ult. 7 Dias', padrao: true, sortable: true },
    { value: 'faturamento_ultimos_30_dias', text: 'Faturamento Ult. 30 Dias', padrao: true, sortable: true },
    { value: 'data_ultimo_pedido', text: 'Últ. Pedido', padrao: true, sortable: true },
    { value: 'dominio', text: 'Domínio', padrao: false, sortable: true },
    { value: 'municipio', text: 'Município', padrao: false, sortable: true },
    { value: 'uf', text: 'UF', padrao: false, sortable: true },
    { value: 'database', text: 'DB', padrao: false, sortable: true },
];

const catalogo = criarCatalogoColunas(COLUNAS);

export const { CHAVES_VALIDAS, colunasPadrao, coluna, normalizarColunas } = catalogo;

export default catalogo;
